import moment from 'jalali-moment';
import { useEffect, useState } from 'react';
import orderEnum from '../../enums/orderEnum.tsx';
import { urls } from '../../services/endPoint';
import { api } from '../../services/http';
import { useAppSelector } from '../../services/redux/store';
import { formatPrice } from '../../utils/utils';
import OrderCard from '../orders/orderCard.tsx';

const Current = () => {
  const orderReducer = useAppSelector(state => state.orderReducer)
  const currentOrders = orderReducer.orders.filter(e => e.status == orderEnum.Status.Assigned || e.status == orderEnum.Status.InProgress)?.length > 0 ? orderReducer.orders.filter(e => e.status == orderEnum.Status.Assigned || e.status == orderEnum.Status.InProgress).sort((a, b) => moment(`${a.date} ${a.fromTime}`, 'jYYYY/jMM/jDD HH').unix() - moment(`${b.date} ${b.fromTime}`, 'jYYYY/jMM/jDD HH').unix()) : []

  return (
    <main className="workerDashboardMain">
      <section className="banners">
        {currentOrders.length ? currentOrders.map((e, index) => <OrderCard key={e.id} item={e}/>)
          :
          <span>سفارش فعالی ندارید</span>
        }
      </section>
    </main>
  );
};

export default Current;
